export default {
    SUBMIT_SUCCESS_NANNY_FORM: {
        TITLE: '¡Gracias por su solicitud para unirse a nuestro equipo!',
        MESSAGE: '¡Revisaremos detenidamente su solicitud y nos pondremos en contacto con usted pronto si parece encajar bien en nuestro equipo! Debido al alto volumen de solicitudes que recibimos, solo podemos responder a los candidatos que seleccionamos. ¡Gracias por su comprensión! Ahora puede cerrar esta ventana de forma segura'
    },
    SUBMIT_SUCCESS_REFERENCE_FORM: {
        TITLE: '¡Gracias por su información!',
        MESSAGE: 'La información de referencia que envió es muy importante para nosotros. Puedes cerrar esta ventana con seguridad ahora'
    },
    SUBMIT_SUCCESS_FAMILY_FORM: {
        INNER_HTML: `
        <h2>¡Gracias por enviar su registro!</h2>
        <h5>¡Nos pondremos en contacto contigo en breve! Ahora puede cerrar esta ventana de forma segura.</h5>
        `
    },
    PROFILE_COMPLETE_RESULT_DIALOG: {
        MESSAGE: '¡Gracias por informarnos, nos pondremos en contacto con usted en breve!'
    },
    VIDEO_UPLOADE_RESULT_DIALOG: {
        INNER_HTML: `
        <h2>¡El vídeo se subió correctamente!</h2>
        <h5>Gracias por enviar el video de presentación. Si no se muestra en la pantalla, espere un momento y luego haga clic manualmente en Actualizar (<i class="material-icons" style='position: absolute;'>refresh</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp ;&nbsp;)</h5>
        `
    },
    UPDATE_SECTION_SUCCESS: {
        TITLE: 'Sección guardada',
        MESSAGE: '¡Se guardó la sección {0}!'
    },
    UPDATE_FAMILY_FORM_SUCCESS: {
        TITLE: 'Formulario familiar actualizado',
        MESSAGE: 'Formulario familiar actualizado con éxito'
    },
    UPDATE_SECTION_REJECT: {
        TITLE: 'Gracias',
        MESSAGE: "Revisaremos la información que ha enviado y nos pondremos en contacto con usted si deseamos seguir adelante"
    },
    SUBMIT_REJECT_FORM: {
        TITLE: 'Gracias',
        MESSAGE: "Revisaremos la información que ha enviado y nos pondremos en contacto con usted si deseamos seguir adelante"
    },
    STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Estado actualizado'
    },
    STATUS_UPDATED_REFUND_RESULT_DIALOG: {
        TITLE: 'Estado actualizado. Reembolso al cliente 1 crédito'
    },
    SUCCESSFULLY_BROADCAST_RESULT_DIALOG: {
        TITLE: 'Transmisión enviada!'
    },
    NANNY_ASSIGNED_RESULT_DIALOG: {
        TITLE: '¡Candidato asignado!',
        MESSAGE: 'Proceda a la notificación de cliente y candidato.'
    },
    BULK_ASSIGNED_RESULT_DIALOG: {
        TITLE: "Candidatos asignados",
    },
    JOB_UPDATED_RESULT_DIALOG: {
        TITLE: '¡Trabajo actualizado!'
    },
    JOB_POSTED_RESULT_DIALOG: {
        TITLE: '¡Trabajo publicado!'
    },
    JOB_ACCEPTANCE_TYPE_RESULT_DIALOG: {
        TITLE: 'Tipo de aceptación actualizado'
    },
    JOB_CHARGED_RESULT_DIALOG: {
        TITLE: '¡El cliente cargó y el estado del trabajo se actualizó!'
    },
    CLIENT_CHARGED_RESULT_DIALOG: {
        TITLE: '¡Se ha cobrado al cliente a través de Stripe!'
    },
    BULK_JOBS_CHARGED_RESULT_DIALOG: {
        TITLE: '¡Clientes cobrados y estado de trabajos actualizado!'
    },
    BULK_INVOICE_RESULT_DIALOG: {
        TITLE: "¡Clientes facturados!"
    },
    BULK_TRANSFER_RESULT_DIALOG: {
        TITLE: "¡Clientes cobrados y candidatos pagados y estado de trabajos actualizado!"
    },
    MESSAGE_SENT_RESULT_DIALOG: {
        TITLE: 'Mensaje enviado.'
    },
    CHANGE_PASSWORD_RESULT_DIALOG: {
        TITLE: 'La contraseña se ha restablecido correctamente.'
    },
    SAVE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'La imagen de perfil se ha guardado correctamente.'
    },
    DELETE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'La imagen de perfil se ha eliminado correctamente.'
    },
    DOCUMENT_UPLOADED_RESULT_DIALOG: {
        TITLE: 'Documentos cargados.',
        MESSAGE: "Podrían tardar unos segundos en procesarse. Si no se actualizan de inmediato, intente actualizar en un minuto"
    },
    DOCUMENT_SIGNED_RESULT_DIALOG: {
        TITLE: 'Su documento ha sido firmado.'
    },
    DOCUMENT_SAVED_RESULT_DIALOG: {
        TITLE: 'Su documento ha sido guardado.'
    },
    DOCUMENT_INFORMATION_UPDATED_RESULT_DIALOG: {
        TITLE: 'Se actualiza la información adicional del documento {0}'
    },
    TEMPLATE_CREATED_RESULT_DIALOG: {
        TITLE: 'Plantilla creada.'
    },
    TEMPLATE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Plantilla actualizada'
    },
    TEMPLATE_DELETED_RESULT_DIALOG: {
        TITLE: 'Plantilla eliminada'
    },
    TEMPLATE_DUPLICATED_RESULT_DIALOG: {
        TITLE: 'Plantilla duplicada.'
    },
    PASSWORD_RESET_RESULT_DIALOG: {
        TITLE: 'Restablecimiento de contraseña',
        MESSAGE: 'Contraseña restablecida a {0}'
    },
    PROFILE_BUILDER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Creador de perfiles actualizado'
    },
    EMAIL_FOOTER_SAVED_RESULT_DIALOG: {
        TITLE: 'Se guardó el pie de página del correo electrónico'
    },
    NOTIFICATION_SETTING_SAVED_RESULT_DIALOG: {
        TITLE: 'Configuración de notificación guardada'
    },
    ADDITIONAL_ADMIN_SETTINGS_SAVED_RESULT_DIALOG: {
        TITLE: 'Configuración de administrador adicional guardada'
    },
    MANAGER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Administrador actualizado.'
    },
    ADMIN_ADDED_RESULT_DIALOG: {
        TITLE: 'Administrador agregado'
    },
    ADMIN_UPDATED_RESULT_DIALOG: {
        TITLE: 'Administrador actualizado'
    },
    ADMIN_DELETED_RESULT_DIALOG: {
        TITLE: 'Administrador eliminado'
    },
    LOCATIONS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Ubicaciones actualizadas'
    },
    LANGUAGE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Idioma actualizado'
    },
    JOB_BROADCAST_SENT_RESULT_DIALOG: {
        TITLE: '¡Transmisión enviada a {0} candidatos!'
    },
    JOB_VIEWS_RESULT_DIALOG: {
        TITLE: 'Visualizaciones de trabajos',
        MESSAGE: 'Número de veces visto: {0}'
    },
    BLAST_OFF_RESULT_DIALOG: {
        TITLE: '¡Despegue!',
        MESSAGE: "¡Sus correos electrónicos están en camino! Puede tomar algunos minutos, dependiendo de cuántos se envíen. Aparecerán en el registro de correo electrónico general y en los registros de correo electrónico del usuario individual a medida que se envían"
    },
    NOTE_SAVED_RESULT_DIALOG: {
        TITLE: '¡Nota guardada!'
    },
    SAVE_AND_ADD_NEW_OBJECT: {
        TITLE: '{0} guardado, ¡agrega otro!',
        CLOSE_LABEL: 'OK'
    },
    APPLICATION_STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: '¡Gracias por informarnos!'
    },
    JOB_ACCEPTED_RESULT_DIALOG: {
        TITLE: "¡Felicitaciones, has aceptado este trabajo!",
        MESSAGE: 'Todos los detalles aparecerán aquí y en su tablero en "Mis trabajos".'
    },
    UPDATE_VISIBILITY_SCOPE_RESULT_DIALOG: {
        TITLE: 'El alcance de visibilidad de {0} se actualizó a {1}'
    },
    CHECK_FORM_ACTUALIZADO: {
        TITLE: '{0} formulario de verificación actualizado'
    },
    SAVED_CHANGES_RESULT_DIALOG: {
        TITLE: '¡Cambios guardados!'
    },
    PRICE_CREATED_RESULT_DIALOG: {
        TITLE: 'Precio creado.'
    },
    PRICE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Precio actualizado'
    },
    PRICE_DELETED_RESULT_DIALOG: {
        TITLE: 'Precio eliminado.'
    },
    RELATIONSHIP_CREATED_RESULT_DIALOG: {
        TITLE: '¡Enlace de candidato a cliente actualizado!'
    },
    RELATIONSHIP_UPDATED_RESULT_DIALOG: {
        TITLE: '¡Enlace de candidato a cliente actualizado!'
    },
    OFFER_UPDATED_RESULT_DIALOG: {
        TITLE: '¡Oferta actualizada!'
    },
    REVIEW_SUBMITTED_RESULT_DIALOG: {
        TITLE: '¡Gracias por dejar una reseña!'
    },
    MARKED_FAVORITE_RESULT_DIALOG: {
        TITLE: '¡Marcado como favorito!',
        MESSAGE: 'Haremos todo lo posible para emparejarlo con ellos en el futuro.'
    },
    MARKED_DONT_WANT_RESULT_DIALOG: {
        TITLE: 'Gracias por informarnos',
        MESSAGE: 'Haremos todo lo posible para conectarlo con otros en el futuro'
    },
    PAYMENT_SUBMITTED_RESULT_DIALOG: {
        TITLE: '¡Gracias por enviar su información de pago!'
    },
    PACKAGE_SELECTED_RESULT_DIALOG: {
        TITLE: 'Su paquete ha sido seleccionado, ¡gracias!',
        MESSAGE: "Nuestra búsqueda está en marcha, ¡nos pondremos en contacto pronto!"
    },
    EVALUACIÓN_CREATED_RESULTADO_DIÁLOGO: {
        TITLE: "Evaluación creada"
    },
    EVALUACIÓN_ACTUALIZADO_RESULTADO_DIÁLOGO: {
        TITLE: "Evaluación actualizada"
    },
    EVALUACIÓN_ELIMINADO_RESULTADO_DIÁLOGO: {
        TITLE: "Evaluación eliminada"
    },
    QUESTION_CREATED_RESULT_DIALOG: {
        TITLE: "Pregunta creada"
    },
    QUESTION_UPDATED_RESULT_DIALOG: {
        TITLE: "Pregunta actualizada"
    },
    QUESTION_DELETED_RESULT_DIALOG: {
        TITLE: "Pregunta eliminada"
    },
    EVALUACIÓN_AÑADIDA_RESULTADO_DIÁLOGO: {
        TITLE: "¡Evaluación agregada!"
    },
    EVALUACIÓN_COMPLETA_RESULTADO_DIÁLOGO: {
        TITLE: "{0} completado, ¡gracias!",
        CLOSE_LABEL: "Listo"
    },
    TIME_OFF_REQUEST_SUBMITTED_RESULT_DIALOG: {
        TITLE: "¡Su solicitud de tiempo libre ha sido enviada, la revisaremos y confirmaremos cuando se apruebe!",
        CLOSE_LABEL: "Listo"
    },
    AVAILABILITY_NOTES_UPDATED_RESULT_DIALOG: {
        TITLE: "¡Notas actualizadas!",
        CLOSE_LABEL: "Continuar"
    },
    BUFFER_TIME_UPDATED_RESULT_DIALOG: {
        TITLE: "¡Tiempo de búfer actualizado!",
    },
    SCHEDULE_UPDATED_RESULT_DIALOG: {
        TITLE: "Horario actualizado"
    },
    DOCUMENT_SEND_TO_CANDIDATE_RESULT_DIALOG: {
        TITLE: "Documento enviado al candidato"
    },
    DOCUMENT_MARK_AS_DRAFT_RESULT_DIALOG: {
        TITLE: "El documento está marcado como borrador"
    },
    DOCUMENT_PUBLISH_RESULT_DIALOG: {
        TITLE: "Documento publicado"
    },
    DOCUMENT_UPDATED_RESULT_DIALOG: {
        TITLE: "El documento está actualizado"
    },
    RESERVA_EN_BLOCKED_DATES_RESULT_DIALOG: {
        TITLE: "Nuestras disculpas, ¡estamos reservados para esta fecha! Lo agregaremos a nuestra lista de cancelaciones y le informaremos de cualquier cambio lo antes posible",
        CLOSE_LABEL: "Continuar"
    },
    CHECKLIST_SAVED_RESULT_DIALOG: {
        TITLE: "Lista de verificación guardada"
    },
    FEEDBACK_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Gracias, nos pondremos en contacto en breve"
    },
    USER_ALERT_BLOCKED_POPUP_DIALOG: {
        TITLE: "Si no se ha abierto una nueva ventana, verifique si se bloquearon las ventanas emergentes",
        CLOSE_LABEL: "Cancelar"
    },
    CLOCK_OUT_SUCCESS_RESULT_DIALOG: {
        TITLE: "¡Gracias!",
        MESSAGE: "Si hubo algún problema con el registro de la hora o cualquier otra cosa, háganoslo saber",
        CLOSE_LABEL: "Listo"
    },
    CLOCK_IN_SUCCESS_RESULT_DIALOG: {
        TITLE: "¡Gracias!",
        MESSAGE: "¡No olvides marcar la salida cuando hayas terminado!",
        CLOSE_LABEL: "Listo"
    },
    SCHEDULE_RELEASED_RESULT_DIALOG: {
        TITLE: "¡Se ha publicado el horario!"
    },
    EVENT_BOOKED_RESULT_DIALOG: {
        TITLE: "¡Evento reservado!"
    },
    DOCUMENT_ADDED_RESULT_DIALOG: {
        TITLE: "¡Documento agregado!"
    },
    TENTATIVE_ASSIGN_RESULT_DIALOG: {
        TITLE: "Niñera asignada tentativamente.",
        MESSAGE: "Nadie ha sido notificado, lo serán cuando presiones el botón rojo grande"
    },
    SECTION_PUBLIC_FORM_SUBMITTED: {
        TITLE: "{0} información enviada",
        MESSAGE: "Gracias por enviar la información de {0}. Cierre la ventana o envíe otra {1}"
    },
    CANDIDATE_SELECTED_RESULT_DIALOG: {
        TITLE: "Gracias por seleccionar candidato"
    },
    CLOCK_IN_OUT_APPROVED_RESULT_DIALOG: {
        TITLE: "Las horas de entrada y salida están aprobadas"
    },
    PACKAGE_CREDIT_SELECTED_RESULT_DIALOG: {
        TITLE: '¡{0} Créditos añadidos, gracias!',
    },
    UNASSIGN_CANDIDATE_RESULT_DIALOG: {
        TITLE: "Candidato no asignado"
    },
    SAVED_ADVANCE_SEARCH_RESULT_DIALOG: {
        TITLE: "Búsqueda avanzada guardada"
    },
    REQUEST_TIMEOFF_APPROVED_RESULT_DIALOG: {
        TITLE: "Solicitud aprobada"
    },
    REQUEST_TIMEOFF_DECLINED_RESULT_DIALOG: {
        TITLE: "Solicitud rechazada"
    }
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/result-dialog/es.js